import { render, staticRenderFns } from "./StartupNewYear.vue?vue&type=template&id=720667dc&scoped=true&"
import script from "./StartupNewYear.vue?vue&type=script&lang=js&"
export * from "./StartupNewYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720667dc",
  null
  
)

export default component.exports